import React from 'react';
import { SelectField, MenuItem, TextField } from 'material-ui';
import Icon from '../../../tc-ui/icon';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import { beddingConfigOptions } from '../../../../utils/select-fields';
import CopyPaste from '../../../copy-paste';
import R from 'ramda';

const SingleRoomConfig = ({
  forSingleRoom,
  roomName,
  beddingConfigs,
  removeARoom,
  updateBeddingConfigs, // update bedType or count or add a new { bedType }
}) => {
  const updateOneBedding = (configIndex, beddingIndex, updateQuery) => R.call(R.compose(
    updateBeddingConfigs,
    R.update(configIndex, R.__, beddingConfigs),
    R.update(beddingIndex, R.__, R.prop(configIndex, beddingConfigs)),
    R.merge(R.__, updateQuery),
    R.path([configIndex, beddingIndex])
  ), beddingConfigs);
  const addOneBedding = (configIndex, beddingIndex) => R.call(R.compose(
    updateBeddingConfigs,
    R.update(configIndex, R.__, beddingConfigs),
    R.insert(beddingIndex + 1, { count: 1 }),
    R.prop(configIndex)
  ), beddingConfigs);
  const removeOneBedding = (configIndex, beddingIndex) => R.call(R.compose(
    updateBeddingConfigs,
    R.update(configIndex, R.__, beddingConfigs),
    R.remove(beddingIndex, 1),
    R.prop(configIndex)
  ), beddingConfigs);
  const addOneBeddingConfig = () => updateBeddingConfigs(R.append([{ count: 1 }], beddingConfigs));
  const removeOneBeddingConfig = R.compose(
    updateBeddingConfigs,
    R.remove(R.__, 1, beddingConfigs)
  );
  return (
    <div style={{ marginTop: '0px' }}>
      <div style={{ height: '32px', backgroundColor: '#fafafa', borderTop: '1px solid #ededed', borderBottom: '1px solid #ededed', lineHeight: '32px', marginBottom: '16px' }}>
        <div style={{ marginLeft: '32px', display: 'inline-block' }}>
          {roomName}
        </div>
        <div
          style={{
            display: forSingleRoom ? 'none' : 'inline-block',
            marginRight: '32px',
            lineHeight: '32px',
            verticalAlign: 'middle',
            color: '#ff4081',
            cursor: 'pointer',
            float: 'right',
          }}
          onClick={removeARoom}
        >
          DELETE
        </div>
      </div>
      {
        beddingConfigs.map((config, configIndex) => (
          <TwoColumnRow
            key={configIndex}
            outerContainerStyle={{ display: 'flex', alignItems: 'flex-start', overflow: 'visible' }}
            leftColumnStyle={{ padding: '0 0 4px 32px', width: '45%' }}
            leftColumnContent={(
              <div>
                <span style={{ lineHeight: '45px' }}>{`Bedding Configuration ${configIndex + 1}`}</span>
                <CopyPaste
                  outerDivStyle={{ display: forSingleRoom ? 'none' : 'flex' }}
                  pasteButtonOuterStyle={{ marginLeft: '8px' }}
                  type="bedding-configuration"
                  id={`bedding-configuration-${roomName}-${configIndex}`}
                  copiedContent={{ config }}
                  pasteFunc={copiedContent => updateBeddingConfigs(R.update(configIndex, copiedContent.config, beddingConfigs))}
                />
              </div>
            )}
            rightColumnStyle={{ width: '55%' }}
            rightColumnContent={
              config.map((bedding, beddingIndex) => (
                <div key={beddingIndex} style={{ display: 'flex', width: '100%', marginBottom: '8px', flexWrap: 'wrap' }}>
                  <SelectField
                    iconStyle={{ fill: 'rgba(0, 0, 0, 0.87)' }}
                    hintText="Select Bed Type"
                    hintStyle={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.44)' }}
                    style={{ width: '40%' }}
                    value={bedding.bedType}
                    onChange={(e, _, val) => updateOneBedding(configIndex, beddingIndex, { bedType: val })}
                  >
                    {
                      beddingConfigOptions.map((option, optionIndex) => (
                        <MenuItem key={optionIndex} value={option.value} primaryText={option.label}/>
                      ))
                    }
                  </SelectField>
                  <input
                    value={bedding.count}
                    onChange={({ target: { value } }) => updateOneBedding(configIndex, beddingIndex, { count: value })}
                    type="number"
                    min={1}
                    style={{ width: '15%', textAlign: 'right', fontSize: '25px', position: 'relative', top: '6px', height: '32px', marginLeft: '2%' }}
                  />
                  <Icon
                    className="tc-icon-add"
                    style={{
                      marginLeft: '16px',
                      lineHeight: '24px',
                      width: '28px',
                      height: '28px',
                      verticalAlign: 'middle',
                      border: '2px solid green',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      top: '6px',
                    }}
                    onClick={() => addOneBedding(configIndex, beddingIndex)}
                  />
                  <Icon
                    className="tc-icon-close"
                    style={{
                      marginLeft: '16px',
                      lineHeight: '24px',
                      width: '28px',
                      height: '28px',
                      verticalAlign: 'middle',
                      color: '#ff4081',
                      cursor: 'pointer',
                      top: '8px',
                    }}
                    onClick={() => config.length === 1 ? removeOneBeddingConfig(configIndex) : removeOneBedding(configIndex, beddingIndex)}
                  />
                  {
                    bedding.bedType === 'Other' ? (
                      <TextField
                        hintText="Please specify"
                        value={bedding.other}
                        onChange={({ target: { value } }) => updateOneBedding(configIndex, beddingIndex, { other: value })}
                      />
                    ) : <span/>
                  }
                </div>
              ))
            }
          />
        ))
      }
      <div
        onClick={addOneBeddingConfig}
        className="description-segments-add"
        style={{ color: '#00bcd4', cursor: 'pointer', margin: '0 0 16px 32px' }}
      >
        <Icon className="tc-icon-add description-segments-add-icon"/>
        <span className="description-segments-add-label" style={{ fontSize: '14px' }}>Add Another Bedding Configuration for {roomName || 'this room'}</span>
      </div>
    </div>
  );
};

export default SingleRoomConfig;



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/bedding-config/single-room.jsx